module.exports = __webpack_public_path__ + "static/media/pattern.732a803f.png";